import React, {useCallback, useState} from 'react'
import {Button, Heading, HStack, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Stack, Text, UseModalProps, useToast} from "@chakra-ui/react";
import ServerService from "../services/ServerService";
import {User} from "../entities/User";
import {shortFullName} from "../utils/environments";

interface AccountDeleteModalProps extends UseModalProps {
    account: User,
    onRemoved?: (account: User) => void
}

const AccountDeleteModal = ({account, onRemoved, ...props}: AccountDeleteModalProps) => {
    //initial components
    const toast = useToast()

    //initial props
    const [isLoading, setIsLoading] = useState<boolean>(false)

    //initial actions
    const onDeleteUserRequest = useCallback((account: User) => {
        if (!account.id)
            return

        setIsLoading(true)
        ServerService.deleteUser(account.id)
            .then(() => {
                toast({
                    title: 'Пользователь успешно удален',
                    description: `Пользователь ${shortFullName(account.fullName)} удален`,
                    status: 'success',
                    position: 'top'
                })

                onRemoved && onRemoved(account)
                props.onClose()
            })
            .catch(error => {
                toast({
                    title: `Ошибка удаления пользователя ${shortFullName(account.fullName)}`,
                    description: error?.response?.data ?? "Незивестная ошибка",
                    status: 'error',
                    position: 'top'
                })
            })
            .finally(() => setIsLoading(false))
    }, [])

    //build view
    return (
        <Modal
            isCentered
            size={'md'}
            closeOnOverlayClick={false}
            closeOnEsc={false}
            scrollBehavior={'inside'}
            motionPreset='scale'
            returnFocusOnClose={false}
            {...props}>
            <ModalOverlay bg={'blackAlpha.300'} backdropFilter={{lg: 'blur(10px)'}}/>
            <ModalContent bg={'#fcfcfc'} rounded={'xl'}>
                <ModalHeader>
                    <Heading color={'red.500'} fontSize={'xl'} fontWeight={'medium'} userSelect={'none'}>Удаление пользователя</Heading>
                </ModalHeader>
                <ModalBody pb={'5'}>
                    <Stack spacing={'5'}>
                        <Text>{`Вы действительно хотите удалить пользователя ${account.fullName} ?`}</Text>
                        <HStack>
                            <Button isLoading={isLoading} flex={'1'} onClick={() => onDeleteUserRequest(account)} colorScheme={'red'}>Удалить</Button>
                            <Button isDisabled={isLoading} flex={'1'} onClick={props.onClose} variant={'ghost'} color={'blackAlpha.800'}>Отмена</Button>
                        </HStack>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default AccountDeleteModal